import { render, staticRenderFns } from "./AddCustomRole.vue?vue&type=template&id=20afcab2&scoped=true&"
import script from "./AddCustomRole.vue?vue&type=script&lang=js&"
export * from "./AddCustomRole.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomRole.vue?vue&type=style&index=0&id=20afcab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afcab2",
  null
  
)

export default component.exports